import { ROUTE_PATHS } from "./constants/Router";
import Analytics from "./pages/analytics/Analytics";
import Flag from "./pages/analytics/Flag";
import Selling from "./pages/analytics/Selling";
import AppConnectPage from "./pages/app-connect/AppConnect";
import CardManage from "./pages/card-manage/CardManage";
import ChangePassword from "./pages/change-password/ChangePassword";
import CancelDeleteAccount from "./pages/delete-account/CancelDeleteAccount";
import DeleteAccount from "./pages/delete-account/DeleteAccount";
import DeleteAccountDetails from "./pages/delete-account/DeleteAccountDetails";
import EditCardManage from "./pages/edit-card-manage/EditCardManage";
import EditInfo from "./pages/edit-info/EditInfo";
import FindIdResult from "./pages/find-id-result/FindIdResult";
import FindId from "./pages/find-id/FindId";
import FindPassword from "./pages/find-password/FindPassword";
import HistoryPayment from "./pages/history-payment/HistoryPayment";
import Home from "./pages/home/Home";
import More from "./pages/more-page/MorePage";
import Notification from "./pages/notification/Notification";
import PremiumService from "./pages/premium-service/PremiumService";
import PremiumIntro from "./pages/premiumIntro/PremiumIntro";
import ReasonOfDeletion from "./pages/reason-of-deletion/ReasonOfDeletion";
import Representative from "./pages/representative/Representative";
import EditReview from "./pages/review/EditReview";
import Review from "./pages/review/Review";
import ReviewSettingAdditionalCommentSetting from "./pages/review/ReviewSettingAdditionalCommentSetting";
import SignIn from "./pages/sign-in/SignIn";
import TermAndPolicy from "./pages/term-and-policy/TermAndPolicy";
import TermAndPolicyDetails from "./pages/term-and-policy/TermAndPolicyDetails";
import VerifyCode from "./pages/verify-code/VerifyCode";
import ViewEditCardManage from "./pages/view-edit-card-manage/ViewEditCardManage";
import CancelPremiumDeleteRequest from'./pages/premium-service/CancelPremiumDeleteRequest';
import NotFound from "./pages/error/NotFound";
import ChangePasswordResult from "./pages/change-password-result/ChangePasswordResult";

export const clientAnonymousRouters = [
  {
    href: ROUTE_PATHS.SignIn,
    component: SignIn,
    loginRequired: false,
    hideLogoHeader: false,
     hideFooter: true,
  },
  {
    href: ROUTE_PATHS.FindId,
    component: FindId,
    loginRequired: false,
    hideLogoHeader: true,
     hideFooter: true,
  },

  {
    href: ROUTE_PATHS.FindPassword,
    component: FindPassword,
    loginRequired: false,
    hideLogoHeader: true,
     hideFooter: true,
  },

  {
    href: ROUTE_PATHS.VerifyCode,
    component: VerifyCode,
    loginRequired: false,
    hideLogoHeader: true,
     hideFooter: true,
  },

  {
    href: ROUTE_PATHS.FindIdResult,
    component: FindIdResult,
    loginRequired: false,
    hideLogoHeader: true,
     hideFooter: true,
  },

  {
    href: ROUTE_PATHS.ChangePassword,
    component: ChangePassword,
    loginRequired: false,
    hideLogoHeader: true,
     hideFooter: true,
  },
];

export const clientRouters = [
  {
    href: ROUTE_PATHS.Home,
    component: Home,
    loginRequired: true,
    hideFooter: false,
    hideLogoHeader: true,
  },
  {
    href: ROUTE_PATHS.Review,
    component: Review,
    loginRequired: true,
    hideFooter: false,
    hideLogoHeader: false,
  },
  {
    href: ROUTE_PATHS.EditReview,
    component: EditReview,
    loginRequired: true,
    hideFooter: false,
    hideLogoHeader: false,
  },
  {
    href: ROUTE_PATHS.ReviewAdditionalComment,
    component: ReviewSettingAdditionalCommentSetting,
    loginRequired: true,
    hideFooter: false,
    hideLogoHeader: false,
  },
  {
    href: ROUTE_PATHS.PremiumIntro,
    component: PremiumIntro,
    loginRequired: true,
    hideFooter: false,
    hideLogoHeader: true,
  },
  {
    href: ROUTE_PATHS.EditInfo,
    component: EditInfo,
    loginRequired: true,
    hideFooter: true,
    hideLogoHeader: true,
  },
  {
    href: ROUTE_PATHS.DeleteAccount,
    component: DeleteAccount,
    loginRequired: true,
    hideFooter: true,
    hideLogoHeader: true,
  },
  {
    href: ROUTE_PATHS.AppConnect,
    component: AppConnectPage,
    loginRequired: true,
    hideFooter: true,
    hideLogoHeader: true,
  },
  {
    href: ROUTE_PATHS.PremiumServiceManagement,
    component: PremiumService,
    loginRequired: true,
    hideFooter: true,
    hideLogoHeader: true,
  },
  {
    href: ROUTE_PATHS.CancelPremiumDeleteRequest,
    component: CancelPremiumDeleteRequest,
    loginRequired: true,
    hideFooter: true,
    hideLogoHeader: true,
  },
  {
    href: ROUTE_PATHS.DeleteAccountDetails,
    component: DeleteAccountDetails,
    loginRequired: true,
    hideFooter: true,
    hideLogoHeader: true,
  },
  {
    href: ROUTE_PATHS.CancelDeleteAccount,
    component: CancelDeleteAccount,
    loginRequired: true,
    hideFooter: true,
    hideLogoHeader: true,
  },
  {
    href: ROUTE_PATHS.Representative,
    component: Representative,
    loginRequired: true,
    hideFooter: true,
    hideLogoHeader: true,
  },

  {
    href: ROUTE_PATHS.DeleteReason,
    component: ReasonOfDeletion,
    loginRequired: true,
    hideFooter: true,
    hideLogoHeader: true,
  },

  {
    href: ROUTE_PATHS.TermAndPolicy,
    component: TermAndPolicy,
    loginRequired: false,
    hideFooter: true,
    hideLogoHeader: true,
  },

  {
    href: ROUTE_PATHS.TermAndPolicyDetails,
    component: TermAndPolicyDetails,
    loginRequired: false,
    hideFooter: true,
    hideLogoHeader: true,
  },
  {
    href: ROUTE_PATHS.CardManage,
    component: CardManage,
    loginRequired: true,
    hideFooter: true,
    hideLogoHeader: true,
  },
  {
    href: ROUTE_PATHS.EditCardManage,
    component: EditCardManage,
    loginRequired: true,
    hideFooter: true,
    hideLogoHeader: true,
  },
  {
    href: ROUTE_PATHS.ViewEditCardManage,
    component: ViewEditCardManage,
    loginRequired: true,
    hideFooter: true,
    hideLogoHeader: true,
  },
  {
    href: ROUTE_PATHS.HistoryPayment,
    component: HistoryPayment,
    loginRequired: true,
    hideFooter: true,
    hideLogoHeader: true,
  },
  {
    href: ROUTE_PATHS.Notification,
    component: Notification,
    loginRequired: true,
    hideFooter: true,
    hideLogoHeader: true,
  },
  {
    href: ROUTE_PATHS.Analytics,
    component: Analytics,
    loginRequired: true,
    hideFooter: false,
    hideLogoHeader: false,
  },
  {
    href: ROUTE_PATHS.AnalyticsSelling,
    component: Selling,
    loginRequired: true,
    hideFooter: false,
    hideLogoHeader: false,
  },
   {
    href: ROUTE_PATHS.AnalyticsFlag,
    component: Flag,
    loginRequired: true,
    hideFooter: false,
    hideLogoHeader: false,
  },
  {
    href: ROUTE_PATHS.More,
    component: More,
    loginRequired: true,
    hideFooter: false,
    hideLogoHeader: false,
  },
  {
    href: ROUTE_PATHS.NotFound,
    component: NotFound,
    loginRequired: false,
    hideFooter: true,
    hideLogoHeader: true,
  },
  {
    href: ROUTE_PATHS.ChangePasswordResult,
    component: ChangePasswordResult,
    loginRequired: false,
    hideLogoHeader: true,
    hideFooter: true,
  },
];

export const anonymousRouters = [...clientAnonymousRouters];

export const authorizedRouters = [...clientRouters];

export const appRoutes = [...authorizedRouters, ...anonymousRouters];
